import { render, staticRenderFns } from "./SchoolCommission.vue?vue&type=template&id=46e13054&scoped=true&"
import script from "./SchoolCommission.vue?vue&type=script&lang=js&"
export * from "./SchoolCommission.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCommission.vue?vue&type=style&index=0&id=46e13054&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e13054",
  null
  
)

export default component.exports